<p-messages key="info"></p-messages>
<p-toast key="toast" position="top-left" [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="card" *ngIf='displayState.workingDiv'>
    <div class="card-body">
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner>
            </div>
        </div>
    </div>
</div>


<div class="card bg-light" style="margin-top: 5px;">
    <div class="card-body"style="margin-bottom: 3px;">
        <div class="row">
            <div class="col-md-12 bold" style="text-align: center;"><h4>Statistics Charts</h4></div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-8 offset-3">
                <label for="cmbYear" class="col-form-label">Roll Year</label>
                <span style="margin-left: 10px;">
                    <select id="cmbYear" class="col-sm-1" [(ngModel)]='myYear'>
                        <option></option>
                        <option *ngFor="let year of yearList">{{year}}</option>
                    </select>
                </span>
                <span style="margin-left: 10px;">
                    <button class="btn btn-success" title="Click to generate stats and draw charts for selected Roll Year" (click)="runCaseStatsReport()">Generate Case Statistics</button>
                </span>
                <span style="margin-left: 40px;">
                    Chart Type
                    <select [(ngModel)]="chartType" (change)="onChangeType()">
                        <option>line</option>
                        <option>bar</option>
                        <option>pie</option>
                    </select>
                </span>
                <span style="margin-left: 40px;">
                    <button class="btn btn-info" title="Click to export case data to Excel" (click)="exportExcel()">Export</button>
                </span>
            </div>
        </div>
    </div>
</div>

<div *ngIf='displayState.chartDiv'>
  <div class="row container">
    <div class="col-md-12">
      <p-chart #myChartAssessor [type]="chartType" [data]="assessorData" [options]="assessorChartOptions" width="90vw" height="60vh" (onDataSelect)="selectAssessorData($event)"></p-chart>
    </div>

  </div>
  <hr />
    <div class="row container" *ngIf='displayState.valDiffDiv'>
        <div class="col-md-12">
            <p-chart #myChart [type]="chartType" [data]="valueDiffData" [options]="valChartOptions" width="90vw" height="60vh" (onDataSelect)="selectValData($event)">
            </p-chart>
        </div>
    </div>
    <hr />
    <div class="row container">
        <div class="col-md-12">
            <p-chart #myChartOther [type]="chartType" [data]="dynoChartData" [options]="chartOptions" width="90vw" height="60vh" (onDataSelect)="selectData($event)"></p-chart>
        </div>
    </div>
</div>
<div [hidden]="true">
  <hr />
  <div class="row">
    <div class="col-md-8 offset-1">
      <label for="fixYear" class="col-form-label">Case Year</label>
      <span style="margin-left: 10px;">
                    <select id="fixYear" class="col-sm-3" [(ngModel)]='fixYear'>
                        <option></option>
                        <option *ngFor="let year of yearList">{{year}}</option>
                    </select>
                </span>
                <span style="margin-left: 10px;">
                  <button class="btn btn-danger" title="Click to FIX missing dateClosed data" (click)="fixDateClosed()">Fix Date Closed</button>
                </span>
    </div>
  </div>
</div>

